<template>
  <v-layout>
    <v-flex>
      <h1 class="headline text-sm-left">{{bookingTitle}}</h1>
      <v-card>
        <v-container fluid grid-list-xs>
          <v-layout row wrap>
            <v-flex sm4 class="pr-2">
              <date-picker
                customLabel="Start Date"
                @onDateSelected="onStartDateSelected"
                :gtDateString="defaultStartDate"
              ></date-picker>
            </v-flex>
            <v-flex sm2 class="pr-2">
              <v-text-field label="Duration" v-model.number="duration" type="number" min="0"></v-text-field>
            </v-flex>
            <v-flex sm2 class="pr-2">
              <v-text-field label="Adults" v-model="itinerary.adults" type="number" min="0"></v-text-field>
            </v-flex>
            <v-flex sm2 class="pr-2">
              <v-text-field label="Children" v-model="itinerary.children" type="number" min="0"></v-text-field>
            </v-flex>
            <v-flex sm2 class="pr-2">
              <v-text-field label="Infants" v-model="itinerary.infants" type="number" min="0"></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex sm4>
              <v-text-field
                label="Lead Name"
                class="pr-2"
                v-model="leadParticipant.name"
                @input="$v.leadParticipant.name.$touch()"
                @blur="$v.leadParticipant.name.$touch()"
                :error-messages="nameErrors"
                filled
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                label="Lead Surname"
                class="pr-2"
                v-model="leadParticipant.surname"
                @input="$v.leadParticipant.surname.$touch()"
                @blur="$v.leadParticipant.surname.$touch()"
                :error-messages="surnameErrors"
                filled
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-text-field
                label="Lead Email"
                v-model="leadParticipant.email"
                @input="$v.leadParticipant.email.$touch()"
                @blur="$v.leadParticipant.email.$touch()"
                :error-messages="emailErrors"
                filled
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
      <h1 class="headline text-sm-left pt-3">Services</h1>
      <v-card>
        <v-container fluid grid-list-xs>
          <v-progress-circular v-show="$apollo.loading" indeterminate :size="50" color="primary"></v-progress-circular>
          <v-flex
            xs12
            class="text-xs-center pt-3 pb-3"
            v-if="availableServicesArray.length == 0"
          >No content found for selected criteria.</v-flex>
          <v-fade-transition>
            <v-list two-line subheader v-show="!$apollo.loading">
              <template v-for="(service,index) in availableServicesArray">
                <v-divider v-if="index !== 0" :key="`${service.node.id}-divider`"></v-divider>
                <service-item
                  :key="service.node.id"
                  :service="service.node"
                  :itinerary="itinerary"
                  :startDate="selectedStartDate"
                  :endDate="selectedEndDate"
                  @onChange="onChangeServiceItem($event)"
                ></service-item>
              </template>
            </v-list>
          </v-fade-transition>
        </v-container>
      </v-card>
      <v-container>
        <v-layout v-if="availableServicesArray.length != 0" justify-center>
          <v-btn @click="onSaveBooking" :disabled="itineraryItems.length === 0">Book Now</v-btn>
        </v-layout>
        <v-layout justify-center>
          <v-btn
            v-show="showScrollBtn"
            fab
            dark
            fixed
            bottom
            right
            color="primary"
            @click="toBottom"
          >
            <v-icon>keyboard_arrow_down</v-icon>
          </v-btn>
        </v-layout>
      </v-container>
    </v-flex>
  </v-layout>
</template>

<script>
import {
  AVAILABLE_SERVICES_SEARCH_QUERY,
  ITINERARY_CREATE_MUTATION
} from "../../../../constants/graphql";
import ServiceItem from "./SupplierBookingServiceItem";
import DatePicker from "../../shared/DatePicker";
import { required, email } from "vuelidate/lib/validators";
import gql from "graphql-tag";

export const SUPPLIER_QUERY = gql`
  query supplier($supplierId: ID!) {
    supplier(id: $supplierId) {
      id
      name
      serviceType
      destination {
        id
        name
      }
    }
  }
`;

export default {
  name: "SupplierBooking",

  components: {
    DatePicker,
    ServiceItem
  },

  data() {
    return {
      supplierId: this.$route.params.id,
      debug: false,
      defaultAgentId: this.$store.getters.agentId,
      availableServices: {},
      availableServicesArray: [],
      itineraryItems: [],
      supplier: {},
      skipServices: true,
      duration: 1,
      loader: false,
      leadParticipant: {
        name: "",
        surname: "",
        email: "",
        isLeader: true
      },
      itinerary: {
        adults: "2",
        children: "0",
        infants: "0"
      },
      defaultStartDate: new Date().toISOString(),
      selectedStartDate: new Date().toISOString(),
      selectedEndDate: "",
      showScrollBtn: false
    };
  },

  methods: {
    toBottom() {
      let height = this.$refs.mainContainer.clientHeight;
      this.$vuetify.goTo(height);
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
    onStartDateSelected(data) {
      this.itinerary.startDate = data;
      this.selectedStartDate = data;
    },
    endDate() {
      let date = new Date(this.selectedStartDate);
      date.setDate(date.getDate() + this.duration);
      return date;
    },
    onChangeServiceItem(data) {
      let currentItem = {};

      for (let i = 0; i < this.itineraryItems.length; i++) {
        if (this.itineraryItems[i].serviceId === data.serviceId) {
          currentItem = this.itineraryItems[i];
        }
      }

      if (currentItem.serviceId == null && !this.isItemEmpty(data)) {
        this.itineraryItems.push(data);
      } else {
        if (this.isItemEmpty(data)) {
          let currentItemIndex = this.itineraryItems.indexOf(currentItem);
          this.itineraryItems.splice(currentItemIndex, 1);
        } else {
          currentItem.adults = data.adults;
          currentItem.children = data.children;
          currentItem.infants = data.infants;
        }
      }
    },

    isItemEmpty(data) {
      return data.adults == 0 && data.children == 0 && data.infants == 0;
    },

    onSaveBooking() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let variables = this.getItineraryVariables();
        let mutation = ITINERARY_CREATE_MUTATION;
        this.$apollo
          .mutate({
            mutation: mutation,
            variables: variables
          })
          .then(this.saveGqlObjectHandler, this.saveGqlObjectErrorHandler);
      } else {
        this.toTop();
      }
    },

    saveGqlObjectHandler(result) {
      if (result.data.hasOwnProperty("createItinerary")) {
        const itData = result.data.createItinerary;
        this.id = itData.id;
        this.$router.push("/itinerary/" + this.id + "/details");
      }
    },
    saveGqlObjectErrorHandler(err) {
      console.log(err);
    },

    getItineraryVariables() {
      let variables = {
        adults: this.itinerary.adults,
        children: this.itinerary.children,
        infants: this.itinerary.infants,
        department: "FIT",
        startDate: this.selectedStartDate,
        endDate: this.selectedEndDate,
        destinationId: this.supplier.destination.id,
        agentId: this.defaultAgentId,
        items: this.itineraryItems,
        participants: [this.leadParticipant]
      };

      return variables;
    }
  },

  computed: {
    bookingTitle() {
      return "Booking - " + this.supplier.name;
    },
    nameErrors() {
      let errors = [];
      if (!this.$v.leadParticipant.name.$dirty) {
        return errors;
      }
      if (!this.$v.leadParticipant.name.required) {
        errors.push("Name is required.");
      }
      return errors;
    },
    surnameErrors() {
      let errors = [];
      if (!this.$v.leadParticipant.surname.$dirty) {
        return errors;
      }
      if (!this.$v.leadParticipant.surname.required) {
        errors.push("Surname is required.");
      }
      return errors;
    },
    emailErrors() {
      let errors = [];
      if (!this.$v.leadParticipant.email.$dirty) {
        return errors;
      }
      if (!this.$v.leadParticipant.email.required) {
        errors.push("Email is required.");
      }

      if (!this.$v.leadParticipant.email.email) {
        errors.push("Input must be an email.");
      }
      return errors;
    }
  },

  watch: {
    supplier(data) {
      if (data.destination != null) {
        this.skipServices = false;
      }

      this.selectedEndDate = this.endDate().toISOString();
    },
    selectedStartDate() {
      this.itineraryItems = [];
      this.loader = true;
      this.selectedEndDate = this.endDate().toISOString();
      this.$apollo.queries.availableServices.refetch();
    },
    duration() {
      this.itineraryItems = [];
      this.loader = true;
      this.selectedEndDate = this.endDate().toISOString();
      this.$apollo.queries.availableServices.refetch();
    },

    availableServices(data) {
      this.availableServicesArray = data.edges;
    },

    availableServicesArray(data) {
      let windowHeight = document.documentElement.clientHeight;
      let contentHeight = data.length * 72 + 395;

      this.showScrollBtn = contentHeight > windowHeight;
    }
  },

  apollo: {
    supplier: {
      query: SUPPLIER_QUERY,
      variables() {
        return {
          supplierId: this.supplierId
        };
      },
      fetchPolicy: "network-only",
      result(data) {}
    },
    availableServices: {
      query: AVAILABLE_SERVICES_SEARCH_QUERY,
      variables() {
        return {
          agentId: this.defaultAgentId,
          destinationId: this.supplier.destination.id,
          startDate: new Date(this.selectedStartDate),
          serviceType: this.supplier.serviceType,
          adults: this.itinerary.adults.toString(),
          children: this.itinerary.children.toString(),
          infants: this.itinerary.infants.toString(),
          endDate: this.endDate(),
          supplierName: this.supplier.name
        };
      },
      skip() {
        return this.skipServices;
      },
      fetchPolicy: "network-only",
      result(data) {
        this.loader = false;
      }
    }
  },

  validations: {
    leadParticipant: {
      name: { required },
      surname: { required },
      email: { required, email }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/gt/suppliers/booking/SupplierBooking.vue